// src/pages/HomePage.js
import React from 'react';
import Hero from '../components/Hero';
import AboutDetails from '../components/AboutDetails';
import ContactUs from '../components/ContactUs';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import WhyChooseUs from '../components/WhyChooseUs'
import Accreditation from '../components/Accreditation';
import Stats from '../components/Stats';
import Testimonials from '../components/Testimonials';



const HomePage = () => {
  return (
    <div>
      <Navbar />
      <Hero />
      <AboutDetails />
      <ContactUs/>
      <WhyChooseUs/>
      <Accreditation />
      <Stats />
      <Testimonials />
      <Footer />
    </div>
  );
};

export default HomePage;
